import { LarchSys } from '../../utils/larchSys';
import "./_marquee.scss";


export function marqueeFeature(larchSys: LarchSys) {

    // const element = document.querySelector<HTMLElement>('.marquee');

    const elements = document.querySelectorAll<HTMLElement>('.marquee');

    Array.prototype.forEach.call(elements,
        (element: HTMLElement) => {
            const wrapper = document.createElement('div');
            wrapper.className = 'marquee-contents';

            const first = document.createElement('div');
            first.className = 'marquee-inner';
            first.append(...element.childNodes as any);
            wrapper.appendChild(first);

            const second = first.cloneNode(true) as HTMLElement;
            second.style.paddingRight = '0.2em';
            wrapper.appendChild(second);

            element.appendChild(wrapper);

            {
                const delay = 500;
                const duration = 13000;

                const animation = (
                    wait(delay,
                        animate(duration,
                            draw()
                        )
                    )
                );

                requestAnimationFrame(animation);
            }


            function draw() {

                const width = getWidth();
                const linear = (t: number) => t;

                let oldValue: string = null;

                return (fraction: number) => {
                    const x = lerp(0, width(fraction), linear(fraction)).toFixed(1);

                    if (oldValue !== x) {
                        oldValue = x;
                        wrapper.style.transform = `translateX(-${x}px)`;
                    }
                };

                function getWidth() {
                    let done = false;
                    let width = resize();;

                    return (fraction: number) => {

                        const reminder = Math.abs(fraction * 10 % 1);

                        if (!done && reminder < 0.1) {
                            width = resize();
                            done = true;
                        }
                        else {
                            done = false;
                        }

                        return width;
                    }
                }

                function resize() {
                    const { width } = second.getBoundingClientRect();
                    first.style.transform = `translateX(${width.toFixed(2)}px)`;
                    return width;
                }

                function lerp(min: number, max: number, fraction: number) { return (max - min) * fraction + min; };
            }
        });


    function animate(duration: number, draw: (fraction: number) => void) {
        return (start: number) => requestAnimationFrame(function loop(ticks: number) {

            const fraction = (ticks - start) / duration;

            draw(fraction);

            if (fraction >= 1) start = ticks;

            requestAnimationFrame(loop);
        });
    }


    function wait(delay: number, next: (start: number) => void) {
        return (start: number) => requestAnimationFrame(function loop(ticks: number) {
            if (ticks - start > delay) next(ticks);
            else requestAnimationFrame(loop);
        });
    }

}
